import { render, staticRenderFns } from "./ManageSystemLookups.vue?vue&type=template&id=3a50d034"
import script from "./ManageSystemLookups.vue?vue&type=script&lang=js"
export * from "./ManageSystemLookups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports